module.exports = __webpack_public_path__ + "img/mayun.805558fc.jpg";